import React, { useState } from 'react'
import { connect } from 'react-redux'
import { isEmail, isEmpty } from 'validator'

import Meta from '@/components/common/Meta'
import { usePopupAlerts } from '@/v1/hooks'
import { STATUS } from '@/v1/constants/status'
import { META_CONTENTS } from '@/v1/constants/seo'
import { ResetPasswordSrOnly } from '@/v1/sr-only'
import { useErrorValidation } from '@/v1/hooks/hanlder'
import { useAuthentication } from '@/api/api-hooks/auth'
import Promotion from '@/components/sections/Promotion'
import * as actionTypes from '@/store/constants/actionTypes'
import ResetForm from '@/components/subComponents/auth/resetForm'

function ResetPassword(props) {
  const { reset } = useAuthentication()
  const { sendNotification } = usePopupAlerts()
  const { validateErrors } = useErrorValidation()
  const [errors, setErrors] = useState({})
  const [formData, setFormData] = useState({
    email: ''
  })

  const inputOnChangeHandler = e => {
    const name = e.target.name
    let value = e.target.value

    if (!isEmpty(value)) {
      setErrors({})
    }

    setFormData({
      ...formData,
      [name]: value
    })
  }

  const formValidation = () => {
    const errors = {}

    if (isEmpty(formData.email)) {
      errors.email = ['Email is required.']
    } else if (!isEmail(formData.email)) {
      errors.email = ['Invalid email format.']
    }

    const isValid = Object.keys(errors).length === 0

    if (!isValid) {
      setErrors(errors)
    }

    return isValid
  }

  const formOnSubmitHandler = async e => {
    e.preventDefault()
    let validate = formValidation()
    if (validate === true) {
      reset.mutateAsync({ payload: formData }).then(res => {
        if (res?.statusCode === STATUS.BAD_REQUEST) {
          return validateErrors(res.data.errors)
        }

        if (res?.statusCode === STATUS.OK) {
          sendNotification('success', res?.data?.message, { timer: undefined })
        } else {
          sendNotification('error', res?.data?.message)
        }
      })
    }
  }

  return (
    <>
      <Meta
        title={META_CONTENTS.reset_password.title}
        keywords={META_CONTENTS.reset_password.keywords}
        description={META_CONTENTS.reset_password.description}
        noIndex
        noFollow
      />

      <ResetPasswordSrOnly />

      <section className='login-section section-spacing--small'>
        <div className='container'>
          <div className={'max-1170'}>
            <ResetForm
              formData={formData}
              formErrors={errors}
              loading={reset.isPending}
              formOnSubmitHandler={formOnSubmitHandler}
              inputOnChangeHandler={inputOnChangeHandler}
              resetSuccess={props.Auth_Reducer.resetSuccess}
              resetMessage={props.Auth_Reducer.resetMessage}
            />
          </div>
        </div>
      </section>
      <Promotion />
    </>
  )
}

const mapStateToProps = state => {
  return {
    Auth_Reducer: state.authReducer
  }
}
const mapDispatchToProps = dispatch => ({
  onSetBanner: banner => dispatch({ type: actionTypes.SET_PAGE_BANNER, data: banner }),
  onSetHeaderType: headerType => dispatch({ type: actionTypes.SET_HEADER_TYPE, data: headerType })
})
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
